import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../../forecast-app/shared/util/util';
import {trackEvent} from '../../../tracking/amplitude/TrackingV2';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../../../mutations/MutationTypes';
import {
	InsertBaselineTemplateInput,
	InsertBaselineTemplateMutation,
} from './__generated__/InsertBaselineTemplateMutation.graphql';

const mutation = graphql`
	mutation InsertBaselineTemplateMutation($input: InsertBaselineTemplateInput!) {
		insertBaselineTemplate(input: $input) {
			project {
				id
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<InsertBaselineTemplateInput>,
	onSuccess?: RelayOnCompleted<InsertBaselineTemplateMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation<InsertBaselineTemplateMutation>(environment, {
		mutation,
		variables,
		onCompleted: (response, errors) => {
			if (!errors?.length) {
				trackEvent('Baseline Template', 'Inserted');
			}
			onSuccess?.(response, errors);
		},
		onError: onError,
	});
}

export default {commit};
